import React, { PropTypes } from "react";
import { connect } from "react-redux";
import UpcomingWebinarsView from "components/Dashboard/UpcomingWebinars/UpcomingWebinars";
import UpcomingWebinarItem from "components/Dashboard/UpcomingWebinars/UpcomingWebinarItem";
import actions from "actions";
import constants from "constants";
import { push } from "redux-router";
import _ from "lodash";
import axios from "axios";
import { showAddToCalendarModal } from "../../../actions/mixed";

const { UPCOMING_WEBINARS } = constants;

const { subscribeWebinarSaga, unsubscribeWebinarSaga } = actions;

class UpcomingWebinars extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isMobile: !window.matchMedia("(min-width: 800px)").matches,
      subscriptionEvents: {},
      is_subscription_sponsor: this.props.is_subscription_sponsor || false,
    };
  }

  componentWillReceiveProps(props) {
    if (
      !_.isEqual(
        this.props.webinars.is_subscription_sponsor,
        props.webinars.is_subscription_sponsor
      )
    ) {
      this.setState({
        ...this.state,
        is_subscription_sponsor:
          this.props.is_subscription_sponsor || props.is_subscription_sponsor,
      });
    }
    if (!_.isEqual(this.props.subscriptions, props.subscriptions)) {
      this.setState({
        ...this.state,
        subscriptionEvents: {
          ...this.state.subscriptionEvents,
          ...props.subscriptions,
        },
      });
    }
  }

  toggleSponsorsSubscription = (webinar) => {
    this.setState({
      ...this.state,
      is_subscription_sponsor: !this.state.is_subscription_sponsor,
    });
    axios.put("/api/v1/subscription_sponsors/" + webinar.id);
  };

  webinars = () =>
    this.props.webinars.map((webinar) => {
      return (
        <UpcomingWebinarItem
          key={webinar.id}
          webinar={webinar}
          // subscriptions={this.props.subscriptions}
          subscriptions={this.state.subscriptionEvents}
          is_subscription_sponsor={this.state.is_subscription_sponsor}
          toggleSponsorsSubscription={this.toggleSponsorsSubscription}
          userRole={this.props.userRole}
          user={this.props.user}
          onSubscriptionChange={(e, sessionIndex) =>
            this.onSubscriptionChange(e, webinar.id, sessionIndex)
          }
          toggleSubscription={() => this.toggleSubscription(webinar)}
          scrollTo={this.props.scrollTo}
          openAddToCalendarModal={() =>
            this.props.openAddToCalendarModal({ webinarId: webinar.id })
          }
          isMobile={this.state.isMobile}
        />
      );
    });

  onSubscriptionChange = (roomId, webinarId, sessionIndex) => {
    let roomIdByWebinar = this.state.subscriptionEvents[webinarId];
    const roomIdInt = parseInt(roomId);

    if (roomIdByWebinar && roomIdByWebinar.indexOf(roomIdInt) > -1) {
      return;
    }

    roomIdByWebinar = roomIdByWebinar || [];
    roomIdByWebinar[sessionIndex] = roomIdInt;

    this.setState({
      subscriptionEvents: {
        ...this.state.subscriptionEvents,
        [webinarId]: roomIdByWebinar,
      },
    });
  };

  toggleSubscription = (webinar) => {
    const { dispatch, isLogged } = this.props;

    if (!isLogged) {
      dispatch(push("/users/sign_in"));
      return;
    }

    if (webinar.subscription_id) {
      this.props.unsubscribeWebinar(webinar.subscription_id, webinar.id);
    } else {
      this.props.subscribeWebinar(webinar);
    }
  };

  render() {
    return (
      <UpcomingWebinarsView
        nextPage={this.props.nextPage}
        webinars={this.webinars()}
        pagination={this.props.pages > this.props.page}
        count={this.props.count}
      />
    );
  }
}

UpcomingWebinars.propTypes = {
  webinars: PropTypes.array,
  subscribeWebinar: PropTypes.func,
  unsubscribeWebinar: PropTypes.func,
  pages: PropTypes.integer,
};

const mapStateToProps = (state) => ({
  pages: state.webinars[UPCOMING_WEBINARS].pages,
  subscriptions: state.webinars[UPCOMING_WEBINARS].subscriptions,
  isLogged: !_.isEmpty(state.users.user),
  userRole: state.users.user.user_type,
  user: state.users.user,
});

const mapDispatchToProps = (dispatch) => ({
  subscribeWebinar: (webinar) => dispatch(subscribeWebinarSaga(webinar, true)),
  unsubscribeWebinar: (id, weinbarId) =>
    dispatch(unsubscribeWebinarSaga(id, weinbarId)),
  openAddToCalendarModal: (payload) =>
    dispatch(showAddToCalendarModal(payload)),
  dispatch,
});

export default connect(mapStateToProps, mapDispatchToProps)(UpcomingWebinars);



// WEBPACK FOOTER //
// ./src/containers/Dashboard/UpcomingWebinars/UpcomingWebinars.jsx